(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .service('FamilyInformationService', FamilyInformationService);

    FamilyInformationService.$inject = ['$resource','restService','$q','$rootScope'];
    
    function FamilyInformationService ($resource,restService,$q,$rootScope) {
    	
    	
    		
    }
})();